import React from 'react';
import PropTypes from 'prop-types';
import Slider from '../../shared/Slider';
import HorseParentsTree from './HorseParentsTree';

const renderWeatherOverview = (weatherbys, isMobile) => {
    if (!weatherbys) {
        return (
            <section className="hp-weatherbysOverview__container">
                <p className="hp-weatherbysOverview--text-center">No data available</p>
            </section>
        );
    }

    const {
        stallionregister: {
            stallion: {
                media: {
                    item,
                },
            },
        },
    } = weatherbys;

    const slides = item.filter(img => img.mediatype.toLowerCase() === 'carousel image');
    const narrative = item.find(img => img.mediatype.toLowerCase() === 'narrative');
    const contact = item.find(img => img.mediatype.toLowerCase() === 'contact');
    const ad = item.find(img => img.mediatype.toLowerCase() === 'mobile');

    return (
        <section className="hp-weatherbysOverview__container">
            <div className="hp-weatherbysOverview__horse-info-wrapper">
                <Slider slides={slides} hideArrows={isMobile} />
                {!isMobile && narrative &&
                (
                    <div className="hp-weatherbysOverview__horse-info">
                        <img src={narrative.url} alt="narrative" />
                    </div>
                )}
            </div>
            <div className="hp-weatherbysOverview__bannerContainer">
                {
                    !isMobile && contact &&
                    (<img src={contact.url} alt="contaqct" />)
                }
                {
                    isMobile && ad &&
                    (<img src={ad.url} alt="ad" />)
                }
            </div>
        </section>
    );
};

const renderFamilyTree = (bloodstock) => {
    if (!bloodstock) {
        return (
            <div className="family-tree">
                No data available
            </div>
        );
    }

    return (
        <div className="family-tree">
            <div className="family-tree__horse family-tree__horse--current">
                <div className="family-tree__horse-info family-tree__horse-info--current">
                    <h1>{bloodstock.horseName}</h1>
                </div>

                {HorseParentsTree(bloodstock.parents)}
            </div>
        </div>
    );
};

const WeatherbysOverview = (props) => {
    const {
        data,
        isMobile,
    } = props;
    const overviewData = data.data;

    const {
        weatherbys,
        bloodstock,
    } = overviewData;

    if (!weatherbys && !bloodstock) {
        return (
            <div className="family-tree">
                No data available
            </div>
        );
    }

    return (
        <div>
            {renderWeatherOverview(weatherbys, isMobile)}
            {renderFamilyTree(bloodstock)}
        </div>
    );
};

WeatherbysOverview.propTypes = {
    data: PropTypes.shape({
        weatherbys: PropTypes.shape({
            stallionregister: PropTypes.shape({
                generated: PropTypes.string,
                source: PropTypes.string,
                stallion: PropTypes.shape({
                    dam: PropTypes.shape({
                        name: PropTypes.string,
                        yob: PropTypes.string,
                    }),
                    media: PropTypes.shape({
                        item: PropTypes.array,
                    }),
                }),
            }),
        }),

        bloodstock: PropTypes.shape({
            parents: PropTypes.shape({}),
        }),
    }),

    isMobile: PropTypes.bool,
};

export default WeatherbysOverview;



// WEBPACK FOOTER //
// ./src/js/horse/weatherbysOverview/WeatherbysOverview.jsx